import { EventChangeTypesLookup } from "@api-types/event-change-types";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export default class EventChangeTypesApiService {
	static baseUrl = `${WEBPACK_BASE_ADDRESS}platform/event-change-types`;

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getChangeTypes(): Promise<EventChangeTypesLookup> {
		const context = getApiRequestContext();

		return httpClient.get(
			`${this.baseUrl}?translate=true`,
			this.getRequestHeaders(context)
		);
	}
}
